// Entrance animations
import * as arcInMotion from './animation/in/motion/arcIn';
import * as bounceInMotion from './animation/in/motion/bounceIn';
import * as blurInMotion from './animation/in/motion/blurIn';
import * as circleInMotion from './animation/in/motion/circleIn';
import * as curveInMotion from './animation/in/motion/curveIn';
import * as dropInMotion from './animation/in/motion/dropIn';
import * as expandInMotion from './animation/in/motion/expandIn';
import * as fadeInMotion from './animation/in/motion/fadeIn';
import * as floatInMotion from './animation/in/motion/floatIn';
import * as flipInMotion from './animation/in/motion/flipIn';
import * as foldInMotion from './animation/in/motion/foldIn';
import * as glideInMotion from './animation/in/motion/glideIn';
import * as glitchInMotion from './animation/in/motion/glitchIn';
import * as growInMotion from './animation/in/motion/growIn';
import * as punchInMotion from './animation/in/motion/punchIn';
import * as revealInMotion from './animation/in/motion/revealIn';
import * as shapeInMotion from './animation/in/motion/shapeIn';
import * as slideInMotion from './animation/in/motion/slideIn';
import * as spinInMotion from './animation/in/motion/spinIn';
import * as tiltInMotion from './animation/in/motion/tiltIn';
import * as turnInMotion from './animation/in/motion/turnIn';
import * as winkInMotion from './animation/in/motion/winkIn';

// Ongoing animations
import * as bounceMotion from './animation/ongoing/bounce';
import * as breatheMotion from './animation/ongoing/breathe';
import * as crossMotion from './animation/ongoing/cross';
import * as dvdMotion from './animation/ongoing/dvd';
import * as flashMotion from './animation/ongoing/flash';
import * as flipMotion from './animation/ongoing/flip';
import * as foldMotion from './animation/ongoing/fold';
import * as jelloMotion from './animation/ongoing/jello';
import * as pokeMotion from './animation/ongoing/poke';
import * as pulseMotion from './animation/ongoing/pulse';
import * as rubberMotion from './animation/ongoing/rubber';
import * as spinMotion from './animation/ongoing/spin';
import * as swingMotion from './animation/ongoing/swing';
import * as wiggleMotion from './animation/ongoing/wiggle';

// Scroll animations
import * as arcScrollMotion from './animation/scroll/arcScroll';
import * as blurScrollMotion from './animation/scroll/blurScroll';
import * as fadeScrollMotion from './animation/scroll/fadeScroll';
import * as flipScrollMotion from './animation/scroll/flipScroll';
import * as growScrollMotion from './animation/scroll/growScroll';
import * as moveScrollMotion from './animation/scroll/moveScroll';
import * as panScrollMotion from './animation/scroll/panScroll';
import * as parallaxScrollMotion from './animation/scroll/parallaxScroll';
import * as revealScrollMotion from './animation/scroll/revealScroll';
import * as shapeScrollMotion from './animation/scroll/shapeScroll';
import * as shrinkScrollMotion from './animation/scroll/shrinkScroll';
import * as skewPanScrollMotion from './animation/scroll/skewPanScroll';
import * as slideScrollMotion from './animation/scroll/slideScroll';
import * as spin3dScrollMotion from './animation/scroll/spin3dScroll';
import * as spinScrollMotion from './animation/scroll/spinScroll';
import * as stretchScrollMotion from './animation/scroll/stretchScroll';
import * as tiltScrollMotion from './animation/scroll/tiltScroll';
import * as turnScrollMotion from './animation/scroll/turnScroll';

// Mouse animations
import * as tilt3DMouseMotion from './animation/mouse/tilt3DMouse';
import * as swivelMouseMotion from './animation/mouse/swivelMouse';
import * as trackMouseMotion from './animation/mouse/trackMouse';
import * as blobMouseMotion from './animation/mouse/blobMouse';
import * as skewMouseMotion from './animation/mouse/skewMouse';
import * as scaleMouseMotion from './animation/mouse/scaleMouse';
import * as spinMouseMotion from './animation/mouse/spinMouse';
import * as blurMouseMotion from './animation/mouse/blurMouse';
import * as airyMouseMotion from './animation/mouse/airyMouse';
import * as track3DMouseMotion from './animation/mouse/track3DMouse';
import * as bounceMouseMotion from './animation/mouse/bounceMouse';

export {
  // Entrance animations
  arcInMotion,
  bounceInMotion,
  blurInMotion,
  circleInMotion,
  curveInMotion,
  dropInMotion,
  expandInMotion,
  fadeInMotion,
  floatInMotion,
  flipInMotion,
  foldInMotion,
  glideInMotion,
  glitchInMotion,
  growInMotion,
  punchInMotion,
  revealInMotion,
  shapeInMotion,
  slideInMotion,
  spinInMotion,
  tiltInMotion,
  turnInMotion,
  winkInMotion,

  // Ongoing animations
  bounceMotion,
  breatheMotion,
  crossMotion,
  dvdMotion,
  flashMotion,
  flipMotion,
  foldMotion,
  jelloMotion,
  pokeMotion,
  pulseMotion,
  rubberMotion,
  spinMotion,
  swingMotion,
  wiggleMotion,

  // Scroll animations
  arcScrollMotion,
  blurScrollMotion,
  fadeScrollMotion,
  flipScrollMotion,
  growScrollMotion,
  moveScrollMotion,
  panScrollMotion,
  parallaxScrollMotion,
  revealScrollMotion,
  shapeScrollMotion,
  shrinkScrollMotion,
  skewPanScrollMotion,
  slideScrollMotion,
  spin3dScrollMotion,
  spinScrollMotion,
  stretchScrollMotion,
  tiltScrollMotion,
  turnScrollMotion,

  // Mouse animations
  tilt3DMouseMotion,
  swivelMouseMotion,
  trackMouseMotion,
  blobMouseMotion,
  skewMouseMotion,
  scaleMouseMotion,
  spinMouseMotion,
  blurMouseMotion,
  airyMouseMotion,
  track3DMouseMotion,
  bounceMouseMotion,
};
